'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isWeekend;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isWeekend.js
// module id = 566
// module chunks = 0